import React from "react";
import Slideshow from "./Slideshow.js";
import ServiceCard from "./ServiceCard.js";
import "../../styles/LandingPage.css";
// Import images
import acImage from "../../assets/images/services_ac.png";
import heatImage from "../../assets/images/services_heat.png";
import ventilationImage from "../../assets/images/services_ventilation.png";

const services = [
  {
    image: acImage,
    title: "Air Conditioning",
    description:
      "Professional air conditioning installation and repair services.",
  },
  {
    image: heatImage,
    title: "Heating Systems",
    description: "Expert heating system installation and maintenance.",
  },
  {
    image: ventilationImage,
    title: "Ventilation",
    description: "Efficient ventilation solutions for your home or office.",
  },
];

const LandingPage = () => (
  <div className="landing-page">
    <section className="hero">
      <Slideshow />
      <div className="hero-overlay">
        <h1>Expert Heating & Cooling Services</h1>
        <p>Reliable, Family-Owned, and Ready to Serve.</p>
        <a href="/request-service" className="hero-cta-button">
          Request Service Now
        </a>
      </div>
    </section>
    <section className="services-overview">
      <h2>Our Services</h2>
      <p>We offer a wide range of HVAC services to meet your needs...</p>
      <div className="services-cards">
        {services.map((service) => (
          <ServiceCard
            key={service.title}
            image={service.image}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>
    </section>
    <section className="why-choose-us">
      <h2>Why Choose Soriano's HVAC?</h2>
      <div className="features-grid">
        <div className="feature-item">
          <div className="feature-icon">🏠</div>
          <h3>Family Owned</h3>
          <p>Personalized service from our family to yours.</p>
        </div>
        <div className="feature-item">
          <div className="feature-icon">🕒</div>
          <h3>24/7 Service</h3>
          <p>Emergency repairs whenever you need them.</p>
        </div>
        <div className="feature-item">
          <div className="feature-icon">✅</div>
          <h3>Licensed & Insured</h3>
          <p>Professional and safe service you can trust.</p>
        </div>
      </div>
    </section>

    <section className="testimonials">
      <h2>What Our Customers Say</h2>
      <div className="testimonials-grid">
        <div className="testimonial-card">
          <p>
            "Soriano's saved us during the heatwave! Fast, professional, and
            fair pricing."
          </p>
          <h4>- Maria R.</h4>
        </div>
        <div className="testimonial-card">
          <p>
            "Best HVAC service in the area. They installed our new heating
            system perfectly."
          </p>
          <h4>- John D.</h4>
        </div>
      </div>
    </section>

    <section className="about-us">
      <h2>About Soriano's HVAC</h2>
      <p>
        Learn more about our company and our commitment to providing top-notch
        HVAC services...
      </p>
      <a href="/about-us" className="read-more-btn">
        Read More
      </a>
    </section>
  </div>
);

export default LandingPage;
